import backgroundImage from "../assets/img/37290394_8369135.jpg";
import LoginForm from "../component/auth/Form-login";

const LoginPage = () => {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="p-8 bg-white rounded-lg shadow-md">
        <h1 className="text-2xl font-bold text-center text-gray-900 mb-6">
          Đăng nhập
        </h1>
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;
